import { first } from 'lodash'
import { GeneralAPI } from '../../apis/GeneralAPI'
import LegalPage from '../../components/LegalPage'
import { buildLegalMeta, getLegalPageTitle } from '../../helpers/legalPages'

const pendingMessage =
    'The Reseller Agreement is being finalized and will be published here soon.'

export default function ResellerAgreementPage(props) {
    return <LegalPage {...props} />
}

export async function getStaticProps() {
    const data = first(await GeneralAPI.getPageBySlug('reseller-agreement'))
    const title = getLegalPageTitle(data, 'Reseller Agreement')

    const { meta, metaTitle } = buildLegalMeta({
        data,
        title,
        path: '/terms/reseller-agreement',
        description: data?.yoast_head_json?.description || pendingMessage,
    })

    return {
        props: {
            currentPath: '/terms/reseller-agreement',
            data: data || null,
            meta,
            metaTitle,
            pendingMessage: data ? null : pendingMessage,
            title,
        },
        revalidate: 10,
    }
}
